export default "__VITE_ASSET__XOh69SWc__"